import type { ConnectivityState, PingKind } from "@eisox/api/core-api";

enum ConnectivityHistoryTab {
  AVAILABILITY = "availability",
  MESSAGES = "messages",
}

type OutageState = ConnectivityState.DEGRADED | ConnectivityState.DISCONNECTED;

type DayEvent = { kind: OutageState; start: string; end: string } | { kind: PingKind.EARLY; start: string };

export { ConnectivityHistoryTab };
export type { DayEvent, OutageState };
